interface DocketHeaderTextInput {
  orderTypeName: string;
  orderTypeShortName: string;
  salesChannelName?: string;
  staffName?: string;
  showStaffName: boolean;
}

export const getDocketHeaderText = ({
  orderTypeName,
  orderTypeShortName,
  salesChannelName,
  staffName,
  showStaffName,
}: DocketHeaderTextInput): string => {
  let text = orderTypeName;
  if (showStaffName) {
    const staff = staffName?.trim();
    text = staff ? `${orderTypeShortName} | ${staff}` : orderTypeShortName;
  }
  return salesChannelName ? `${salesChannelName} - ${text}` : text;
};
